import { TextField } from "@mui/material";
import { Controller, useFormContext } from "react-hook-form";

interface PropsInterface {
  name: string;
  label: string;
  rules?: any;
  [x: string]: any;
}

export const InputForm = ({ name, label, rules, ...props }: PropsInterface) => {
  const { control, formState } = useFormContext();
  const errors = formState?.errors[name]
    ? formState.errors[name]?.message?.toString()
    : "";
  const limitCounter = props?.inputProps?.maxLength;
  return (
    <Controller
      name={name}
      control={control}
      render={({ field: { onChange, value } }) => (
        <TextField
          label={label}
          onChange={onChange}
          value={value || ""}
          error={formState.errors[name] ? true : false}
          helperText={errors || (limitCounter ? `${value?.length || 0}/${limitCounter}` : "")}
          {...props}
        />
      )}
      rules={rules}
    />
  );
};
